export default "__VITE_ASSET__BxNlSiL4__"